import CongratulationsPage from './CongratulationsPage';
import { CongratulationsPageProps, CongratulationsPageValueProps } from './types';

export type { CongratulationsPageProps, CongratulationsPageValueProps };
export default CongratulationsPage;
